@if (isDiscovery() && !isDismissed()) {

<section
  class="mx-4 mt-[17px] flex flex-col gap-3 rounded-lg border border-primary-300 bg-primary-100/60 p-4 shadow-md"
>
  <div class="flex min-w-0 flex-row justify-between">
    <div class="flex gap-2">
      <app-greentripper-pin-icon
        styleClass="w-7 h-7 text-primary-400 shrink-0"
      ></app-greentripper-pin-icon>
      <h4 class="font-medium text-greyscale-900">
        {{ "demoCTA.title" | transloco }}
      </h4>
    </div>
    <button
      type="button"
      (click)="dismiss()"
      class="flex h-6 w-6 items-center justify-center rounded-full text-greyscale-400 transition-colors hover:text-greyscale-700"
    >
      <i class="pi pi-times text-xs"></i>
    </button>
  </div>
  <div class="flex flex-col justify-between gap-2 sm:flex-row md:gap-4">
    <div>
      <p class="mt-1 text-sm text-greyscale-700 max-md:hidden">
        {{ "demoCTA.description" | transloco }}
      </p>
      <p class="mt-1 text-sm text-greyscale-700 md:hidden">
        {{ "demoCTA.descriptionShort" | transloco }}
      </p>
    </div>
    <div class="flex shrink-0 items-center justify-center gap-2">
      <a
        href="https://outlook.office.com/book/Greentrippersupport@greentripper.org/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <p-button
          icon="pi pi-calendar"
          [label]="'demoCTA.bookADemo' | transloco"
          severity="primary"
        />
      </a>
    </div>
  </div>
</section>
}
